var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form-filtered-multiselect',{attrs:{"options":_vm.countryOptions,"value":_vm.storedCountries,"placeholder":_vm.placeholder,"limit-height":_vm.limitHeight,"hide-selected":_vm.hideSelected,"disabled":_vm.disabled,"track-by":"value","label":"label"},on:{"valuesSelected":_vm.onCountriesSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }